import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';


export default function Planning({ children }) {
   return (
      <div>
         <ul className="nav nav-tabs">
            <li>
               <Link activeClassName="active" to="/planning" onlyActiveOnIndex>Übersicht</Link>
            </li>
            <li>
               <Link activeClassName="active" to="/planning/creation">QS-Runde anlegen</Link>
            </li>
            <li>
               <Link activeClassName="active" to="/planning/assignment">Fall-Zuordnung</Link>
            </li>
            <li>
               <Link activeClassName="active" to="/planning/reviews">evaluierte Fälle</Link>
            </li>
            <li>
               <Link activeClassName="active" to="/planning/labs">Schlaflabore</Link>
            </li>
            <li>
               <Link activeClassName="active" to="/planning/users">Benutzer</Link>
            </li>
            <li>
               <Link activeClassName="active" to="/planning/analysis">Analyse</Link>
            </li>
         </ul>
         <div className="tab-content">
            {children}
         </div>
      </div>
   );
}

Planning.propTypes = {
   children: PropTypes.object,
};

Planning.defaultProps = {
   children: null,
};
